import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { importRequisition, ImportRequisitionRequest } from '../common/api/clients/mariapps.api';
import { queries } from '../common/api/queryKeys/queries';
import { queryClient } from '../lib/queryClient';

export const useMariAppsImportRequisition = () => {
    return useMutation<void, AxiosError<{ error?: string }>, ImportRequisitionRequest>({
        mutationFn: importRequisition,
        onSuccess: () => {
            return queryClient.invalidateQueries({ queryKey: queries.mariAppsFailedRequisitions._def });
        },
        onError: () => {
            return queryClient.invalidateQueries({ queryKey: queries.mariAppsFailedRequisitions._def });
        },
    });
};
